import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Input from '../input';
import RoundCheck from '../round-check';

class ChildrenBlock extends Component {
  static propTypes = {
    data: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        birthday: PropTypes.string,
        gender: PropTypes.number,
      }),
    ),
    fullcase: PropTypes.bool,
  };

  static defaultProps = {
    data: [],
  };

  constructor(props) {
    super(props);

    this.state = {
      data: props.data,
    };
  }

  addChild = () => {
    const data = JSON.parse(JSON.stringify(this.state.data));

    data.push({
      name: '',
      birthday: null,
      genger: null,
    });

    this.setState({ data });
  };

  render() {
    const { data } = this.state;
    const { fullcase } = this.props;

    const children = data.map((child, index) => {
      return (
        <div
          key={`child${child.birthday}${index}`}
          className="inp-list__case inp-group inp-group--2 profile-form"
        >
          <div className="row">
            <div className={`inp-group__case${fullcase ? ' full-case' : ''}`}>
              <Input
                label="ФИО"
                name={`childs[${index}][name]`}
                placeholder="Фамилия Имя Отчество"
                value={child.name || ''}
                indie={true}
              />
            </div>
            <div className={`inp-group__case${fullcase ? ' full-case' : ''}`}>
              <div className="wrap wrap--day">
                <Input
                  date
                  label="Дата рождения"
                  name={`childs[${index}][birthday]`}
                  placeholder="дд.мм.гггг"
                  value={child.birthday || ''}
                  indie={true}
                />
              </div>
              <div className="wrap wrap--gender">
                <div className="round-checks">
                  <RoundCheck
                    checked={child.gender == 0}
                    icon="female"
                    label="Женский"
                    name={`childs[${index}][gender]`}
                    value={0}
                  />
                  <RoundCheck
                    checked={child.gender == 1}
                    icon="male"
                    label="Мужской"
                    name={`childs[${index}][gender]`}
                    value={1}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    });

    return (
      <div className="inp-list inp-list--child">
        {children}
        <div className="inp-list__btn">
          <button
            className="btn btn--outline"
            type="button"
            onClick={this.addChild}
          >
            Добавить информацию
            <svg
              className="btn__icon btn__icon--plus"
              viewBox="0 0 14 14"
              width="10"
              height="10"
            >
              <path d="M12 5h-3v-3c0-1.1-.9-2-2-2s-2 .9-2 2v3h-3c-1.1 0-2 .9-2 2s.9 2 2 2h3v3c0 1.1.9 2 2 2s2-.9 2-2v-3h3c1.1 0 2-.9 2-2s-.9-2-2-2z" />
            </svg>
          </button>
        </div>
      </div>
    );
  }
}

export default ChildrenBlock;
